import { buildComponent, type ComponentElement } from '#components'
import { throttle } from 'lodash'

const HomepageHero = buildComponent({
  name: 'homepage-hero',
  onConnected: (component) => {
    setStickyPosition(component)
    window.addEventListener('resize', () => setStickyPosition(component))

    const detectScroll = detectScrollDirection(component)

    window.addEventListener('scroll', detectScroll)

    window.addEventListener('header-stick', () => swapContent(component, 'heading'))
    window.addEventListener('header-unstick', () => swapContent(component, 'logo'))
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'homepage-hero': typeof HomepageHero
  }
}

function setStickyPosition(component: ComponentElement) {
  const sentinelEl = document.querySelector<HTMLElement>('.js-homepage-hero-sentinel')

  if (!sentinelEl) return

  const stickyOffset = window.innerHeight - sentinelEl.offsetTop

  component.parentElement?.style.setProperty('--hero-sticky-offset', `${stickyOffset}px`)
}

function detectScrollDirection(component: ComponentElement) {
  let lastScrollTop = 0

  return throttle(() => {
    const scrollTop = window.scrollY || window.pageYOffset

    component.dataset.scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up'
    lastScrollTop = Math.max(scrollTop, 0)
  }, 100)
}

function swapContent(component: ComponentElement, targetContent: 'logo' | 'heading') {
  component.dataset.visibleContent = targetContent
}
